import { render, staticRenderFns } from "./FBVoucher.vue?vue&type=template&id=10554c3a&scoped=true&"
import script from "./FBVoucher.vue?vue&type=script&lang=js&"
export * from "./FBVoucher.vue?vue&type=script&lang=js&"
import style0 from "./FBVoucher.vue?vue&type=style&index=0&id=10554c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10554c3a",
  null
  
)

export default component.exports